export default {
  cleanFilters: 'Limpiar filtros',
  titleButton: 'Filtros',
  filtersTitle: 'Filtros',
  cleanFilter: 'Limpiar filtros',
  apply: 'Aplicar',
  stateFilterLabel: 'Estado',
  sponsorFilterLabel: 'Aseguradora',
  dateFilter: 'Fechas',
  dateFieldLabel: 'Rango de fechas',
  documentationLabel: 'Documentación',
  documentation: 'Documentación: {satisfiesDocumentsPolicy}'
}
